import React, { useState, useEffect } from "react";
import "./JobPost.css";
import { FaRegSquarePlus } from "react-icons/fa6";
import ReactQuill from "react-quill";
import "../../../node_modules/react-quill/dist/quill.snow.css";
import { RxCrossCircled } from "react-icons/rx";
import { useDispatch, useSelector } from "react-redux";
import { Alljobpost, CreateJobPosts } from "../../actions/JobPostAction"
import JobCard from '../../components/JobCard/JobCard';
import { Link, NavLink } from 'react-router-dom';

function JobPost() {
  const dispatch = useDispatch();
  const [PopupOpen, setPopupOpen] = useState(false);
  const [values, setValue] = useState("");
  const [jobRole, setJobRole] = useState("");
  const [location, setLocation] = useState("");
  const [experience, setExperience] = useState("");
  const [postion, setPostion] = useState("");
  const [requiredSkill, setRequiredSkill] = useState("");
  const [deleteSuccess, setDeleteSuccess] = useState(null);

  const { allJobPost } = useSelector((state) => state.jobState);

  const Popup = () => {
    setPopupOpen(true);
  };

  const ClosePopup = () => {
    setPopupOpen(false);
  };

  // react quill funtion
  const handleChange = async (e) => {
    setValue(e);
  };
  const handleRequiredChange = async (e) => {
    setRequiredSkill(e);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formdata = new FormData();
    formdata.append("jobRole", jobRole);
    formdata.append("location", location);
    formdata.append("experience", experience);
    formdata.append("postion", postion);
    formdata.append("requiredSkill", requiredSkill);
    formdata.append("keyresponse", values);
    console.log(...formdata);

    try {
      // CreateJobPosts
      await dispatch(CreateJobPosts(formdata));
      setPopupOpen(false);
      window.location.reload();
    } catch (error) {
      console.error("Error Creating New Job Post :", error);
    }
  };

  useEffect(() => {
    dispatch(Alljobpost);
  }, [deleteSuccess, dispatch]);


  return (
    <div className='JobPost_main_div'>
      <div className='JobPost_div'>
        <div className='JobCreate_button_div'>
          <Link to={"/jobpost"} className='JobCreate_Button'>
            Job Post
          </Link>
          <NavLink to={"/alljobdata"} className='JobCreate_Button'>
            All job
          </NavLink>
        </div>
        <div className="JobPost_main_div">
          <div className="JobPost_div">
            <button className="JobCreate_Button" onClick={Popup}>
              Job Post Create{" "}
              <span>
                <FaRegSquarePlus />
              </span>
            </button>
            {PopupOpen && (
              <div className="popup_background">
                <div className="popup_maindiv">
                  <div className="popup_div">
                    <div className="popup">
                      <div className="Job_popup_heading_div">
                        <div className="Job_popup_heading">JOB POST</div>
                        <button type="button" onClick={ClosePopup} className="wrong_btn">
                          <RxCrossCircled className="wrong_icon" />
                        </button>
                      </div>
                      <form onSubmit={handleSubmit} className="Jop_input_main_div">
                        <div className="jop_input_div">
                          <div>Job Role</div>
                          <input
                            className="job_input"
                            type="text"
                            value={jobRole}
                            onChange={(e) => setJobRole(e.target.value)}
                          />
                        </div>
                        <div className="jop_input_div">
                          <div>Location</div>
                          <input
                            className="job_input"
                            type="text"
                            value={location}
                            onChange={(e) => setLocation(e.target.value)}
                          />
                        </div>
                        <div className="jop_input_div">
                          <div>Experience</div>
                          <input
                            className="job_input"
                            type="text"
                            value={experience}
                            onChange={(e) => setExperience(e.target.value)}
                          />
                        </div>
                        <div className="jop_input_div">
                          <div>Position</div>
                          <input
                            className="job_input"
                            type="text"
                            value={postion}
                            onChange={(e) => setPostion(e.target.value)}
                          />
                        </div>
                        <div className="jop_input_div" style={{ marginBottom: "40px" }}>
                          <div>Required Skills</div>
                          <ReactQuill
                            className="job_text_area"
                            placeholder="write some thing"
                            formats={JobPost.formats}
                            modules={JobPost.modules}
                            value={requiredSkill}
                            onChange={handleRequiredChange}
                          />
                        </div>
                        <div className="jop_input_div">
                          <div>Key Responsibilities</div>
                          <ReactQuill
                            className="job_text_area"
                            placeholder="write some thing"
                            formats={JobPost.formats}
                            modules={JobPost.modules}
                            value={values}
                            onChange={handleChange}
                          />
                        </div>
                        <div className="jop_input_div">
                          <input
                            className="job_input_submit"
                            type="submit"
                            value={"submit"}
                          />
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className="jobcard_div">
              {allJobPost?.map((val) => {
                return <JobCard key={val._id} setDeleteSuccess={setDeleteSuccess} val={val} />;
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

JobPost.modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link", "image", "video"],
    ["clean"],
  ],
};
JobPost.formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "color",
  "background",
  "list",
  "bullet",
  "indent",
  "link",
  "video",
  "image",
  "code-block",
  "align",
];

export default JobPost;
